export default {
  namespaced: true,
  state: {
    graphFilter: {
      selectedTab: 0,
    },
    seriesFilter: {
      selectedTab: 0,
    },
    tabSection: {
      selectedTab: 0,
    },
    postSection: {
      selectedTab: 0,
    },
  },
  getters: {
    getGraphfilter: (state) => state.graphFilter.selectedTab,
    getSeriesFilter: (state) => state.seriesFilter.selectedTab,
    getTabSection: (state) => state.tabSection.selectedTab,
    getPostSection: (state) => state.postSection.selectedTab,
  },
  mutations: {
    GRAPH_FILTER_MUTATION(state, obj) {
      state.graphFilter.selectedTab = obj.selected;
    },
    SERIES_FILTER_MUTATION(state, obj) {
      state.seriesFilter.selectedTab = obj.selected;
    },
    TOGGLE_TAB_SECTION(state, obj) {
      state.tabSection.selectedTab = obj.selected;
    },
    TOGGLE_POST_SECTION(state, obj) {
      state.postSection.selectedTab = obj.selected;
    },
  },
  actions: {
    toggleGraphFilter({ commit }, obj) {
      commit("GRAPH_FILTER_MUTATION", obj);
    },
    toggleSeriesFilter({ commit }, obj) {
      commit("SERIES_FILTER_MUTATION", obj);
    },
    toggleTabSection({ commit }, obj) {
      commit("TOGGLE_TAB_SECTION", obj);
    },
    togglePostSection({ commit }, obj) {
      commit("TOGGLE_POST_SECTION", obj);
    },
  },
};
